import { useTranslation } from 'react-i18next';

import { Download } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import {
  EDIT_IMAGE_METHOD,
  MAGIC_TOOL_OPTIONS,
  magicToolOptions,
} from '@/features/image-rendering/constants/toggle-group-options';
import { cn } from '@/lib/utils';

interface ImageRenderingToolbarProps {
  imageId?: string;
  editMethod: EDIT_IMAGE_METHOD;
  magicToolOption: MAGIC_TOOL_OPTIONS;
  onChangeMagicToolOption: (option: MAGIC_TOOL_OPTIONS) => void;
  onDownload: () => void;
}

export const ImageRenderingToolbar = ({
  imageId,
  editMethod,
  magicToolOption,
  onChangeMagicToolOption,
  onDownload,
}: ImageRenderingToolbarProps) => {
  const { t } = useTranslation();

  const generalToolOptions = [
    {
      icon: Download,
      label: t('download'),
      onClick: onDownload,
    },
    // {
    //   icon: Upload,
    //   label: t('Export'),
    //   onClick: handleOpenModal,
    // },
  ];

  return (
    <div className="flex items-center">
      {editMethod === EDIT_IMAGE_METHOD.MAGIC ? (
        <ToggleGroup
          className="gap-2 rounded-sm bg-text-primary px-3 py-2 shadow-lg shadow-black/10"
          type="single"
          disabled={!imageId}
          value={magicToolOption}
          onValueChange={onChangeMagicToolOption}
        >
          {magicToolOptions.map((item, index) => (
            <ToggleGroupItem
              key={`edit-image-method-toggle-item-${index}`}
              className={`h-[24px] rounded-sm px-1 ${magicToolOption === item.value ? '!bg-[#2C414B]' : '!bg-transparent'}`}
              value={item.value}
            >
              <item.icon
                className={cn(
                  '!h-[18px] !w-[18px]',
                  magicToolOption === item.value ? 'text-primary-light' : 'text-white'
                )}
              />
            </ToggleGroupItem>
          ))}
        </ToggleGroup>
      ) : (
        <ButtonGroup className="h-[48px] w-[48px] gap-2 rounded-sm bg-text-primary px-3 py-2 shadow-lg shadow-black/10 sm:h-auto sm:w-auto">
          {generalToolOptions.map((item, index) => (
            <Button
              key={`edit-image-method-toggle-item-${index}`}
              className="my-auto h-[24px] rounded-sm bg-text-primary px-1 hover:!bg-[#2C414B]"
              disabled={!imageId}
              onClick={item.onClick}
            >
              {!!item.label && <span className="mr-2 hidden sm:block">{item.label}</span>}
              <item.icon className="!h-[18px] !w-[18px] text-white" />
            </Button>
          ))}
        </ButtonGroup>
      )}
    </div>
  );
};
